var map = {
	"./add_lightbox.svg": 104,
	"./arrow.svg": 105,
	"./close.svg": 106,
	"./close_lightbox.svg": 107,
	"./copy_lightbox.svg": 108,
	"./create_lightbox.svg": 109,
	"./down.svg": 110,
	"./lightbox_delete_icon.svg": 111,
	"./lightbox_delete_icon_hover.svg": 112,
	"./lightbox_down.svg": 113,
	"./play-button.svg": 114,
	"./share_lightbox.svg": 115,
	"./slashMenu.svg": 116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;